const GlobalConfig = {
    // czy pokazywać kafle i podsumowania bez danych lub ze starymi danymi jako ostrzeżenie
    SHOW_OUTDATED_AS_WARNING: false,
}

export default GlobalConfig;